module.exports = __webpack_public_path__ + "static/media/d8ada5ea-8dd5-4d2a-a9f0-93e563588d8a.13b0085d.jpg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/chicago-council-headshots/dist/img/headshots/d8ada5ea-8dd5-4d2a-a9f0-93e563588d8a.jpg
// module id = 855
// module chunks = 0